export const blockIconsActionSearch = (
	<span className='material-symbols-outlined'>search</span>
);
